import axiosInstance from './axiosInstance';

const SURVEY_BASE_URL = '/Corrohealth/survey';

const unwrap = (response) => response?.data?.data ?? response?.data;

const normalizeOptions = (options = []) => {
  if (!Array.isArray(options)) return [];
  return options
    .map((opt) => {
      if (typeof opt === 'string') return opt.trim();
      return String(opt?.label || opt?.value || '').trim();
    })
    .filter(Boolean);
};

export const surveyApi = {
  createSurvey: async (payload) => {
    const response = await axiosInstance.post(`${SURVEY_BASE_URL}/create`, payload);
    return unwrap(response);
  },

  updateSurvey: async (surveyId, payload) => {
    const response = await axiosInstance.put(`${SURVEY_BASE_URL}/${surveyId}`, payload);
    return unwrap(response);
  },

  updateSurveyStatus: async (surveyId, status) => {
    const response = await axiosInstance.put(`${SURVEY_BASE_URL}/${surveyId}/status`, null, {
      params: { status },
    });
    return unwrap(response);
  },

  getAvailableSurveys: async () => {
    const response = await axiosInstance.get(`${SURVEY_BASE_URL}/form`);
    return unwrap(response);
  },

  getSurveyById: async (surveyId) => {
    const response = await axiosInstance.get(`${SURVEY_BASE_URL}/form/${surveyId}`);
    return unwrap(response);
  },

  submitSurvey: async (payload) => {
    const response = await axiosInstance.post(`${SURVEY_BASE_URL}/submit`, payload);
    return unwrap(response);
  },

  createForm: async (payload) => {
    const response = await axiosInstance.post(`${SURVEY_BASE_URL}/forms`, payload);
    return unwrap(response);
  },

  addQuestion: async (formId, payload) => {
    const body = {
      ...payload,
      options: normalizeOptions(payload?.options),
    };
    const response = await axiosInstance.post(`${SURVEY_BASE_URL}/forms/${formId}/questions`, body);
    return unwrap(response);
  },

  publishForm: async (formId) => {
    const response = await axiosInstance.post(`${SURVEY_BASE_URL}/forms/${formId}/publish`);
    return unwrap(response);
  },

  getForm: async (params = {}) => {
    const response = await axiosInstance.get(`${SURVEY_BASE_URL}/form`);
    return unwrap(response);
  },

  submitForm: async (payload) => {
    const response = await axiosInstance.post(`${SURVEY_BASE_URL}/submit`, payload);
    return unwrap(response);
  },

  getFormAnalytics: async (formId) => {
    const response = await axiosInstance.get(`${SURVEY_BASE_URL}/forms/${formId}/analytics`);
    return unwrap(response);
  },

  getAnalyticsDashboard: async () => {
    const response = await axiosInstance.get(`${SURVEY_BASE_URL}/analytics/dashboard`);
    return unwrap(response);
  },

  getAnalyticsSurveys: async () => {
    const response = await axiosInstance.get(`${SURVEY_BASE_URL}/analytics/surveys`);
    return unwrap(response);
  },

  getAnalyticsResponses: async (surveyId) => {
    const response = await axiosInstance.get(`${SURVEY_BASE_URL}/analytics/${surveyId}/responses`);
    return unwrap(response);
  },

  getAnalyticsPendingUsers: async (surveyId) => {
    const response = await axiosInstance.get(`${SURVEY_BASE_URL}/analytics/${surveyId}/pending`);
    return unwrap(response);
  },
};
